import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Settings from '@/components/Settings'
import SignIn from '@/components/Signin'
import AuthGuard from './AuthGuard'
import NotAuthGuard from './NotAuthGuard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/Settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/',
      name: 'Hello',
      component: Hello,
      beforeEnter: AuthGuard
    },
    {
      path: '/signin/:company?/:emp?',
      name: 'SignIn',
      component: SignIn,
      props: true,
      beforeEnter: NotAuthGuard
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js